import React from 'react'
import { useAuthStore } from '../../store/authStore'
import { getUserType } from '../../utils/userPermissions'
import GovProposalsPage from '../../pages/gov/GovProposalsPage'
import VendorProposalsPage from '../../pages/gov/VendorProposalsPage'

const ProposalRouter: React.FC = () => {
  const { user } = useAuthStore()
  const userType = getUserType(user)

  // For agencies, show proposal review page
  if (userType === 'AGENCY') {
    return <GovProposalsPage />
  }

  // For vendors, show their own proposals page
  if (userType === 'ENTERPRISE_VENDOR') {
    return <VendorProposalsPage />
  }

  // Fallback for other user types
  return <GovProposalsPage />
}

export default ProposalRouter